export default __webpack_public_path__ + "static/media/nolimit.fb2c57e8.svg";